import { Skeleton, Image } from "@chakra-ui/react";
import React from "react";

export default function LazyImage(props) {
	return <Image {...props} />;
}
